import React from 'react';
import classNames from 'classnames';

import s from './loader.scss';

export interface PropsType {
    className?: string;
    size?: number;
    color?: 'blue' | 'white';
}

export const Loader = React.memo<PropsType>(
    ({className = '', size = 90, color = 'blue'}: PropsType) => (
        <div
            aria-label="Content is loading"
            className={classNames(s.loader, className, s[color])}
            style={{width: `${String(size)}px`}}
        >
            <div className={classNames(s.animate, s.first)} />
            <div className={classNames(s.animate, s.second)} />
            <div className={classNames(s.animate, s.third)} />
        </div>
    ),
);
